module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol.js
// module id = 266
// module chunks = 168707334958949